module.exports = __webpack_public_path__ + "img/vishnya.7eda2c53.jpg";